import { SelectOption } from "src/app/@shared/interfaces/select-option.interface";

export enum eLegSection {
    LAST_LEG,
    FIRST_LEG,
}

export const LEG_SECTIONS: SelectOption<eLegSection>[] = [
    {
        label: "התחל נסיעה ברכב",
        value: eLegSection.FIRST_LEG,
        selected: true,
    },
    {
        label: "סיום נסיעה ברכב",
        value: eLegSection.LAST_LEG,
    }
];